package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Composable
fun TLink(label: String, onClick: () -> Unit) {
    TLink({ Text(label) }, onClick)
}

@Composable
fun TLink(label: @Composable () -> Unit, onClick: () -> Unit) {
    A("javascript:void(0);", attrs = {
        classes("font-medium", "text-indigo-600", "hover:text-indigo-900")
        onClick { onClick() }
    }) {
        label()
    }
}